import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const StyledSettingsSectionTitle = styled.div<{ $hasSubtitle: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: ${({ $hasSubtitle }) =>
    $hasSubtitle ? "flex-start" : "center"};
  justify-content: space-between;
  gap: 14px;

  .title-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;

    h2 {
      margin: 0;
      color: ${colors.darkBlue};
      font-size: 16px;
      line-height: 10px;
      letter-spacing: -0.22px;
      text-wrap: nowrap;
      font-weight: 400;
    }

    .subtitle {
      font-size: 10px;
      color: ${colors.blueGray};
      font-weight: 400;
    }
  }

  .upload-button-container {
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      cursor: pointer;
    }
  }
`;
